<template>
    <div>
        <div id="header-container" class="px-5 in-step">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Add Beneficiary') }}</h3>
                <span class="fz-16 fw-400">Fill out the form to create new beneficiary</span>
            </div>

            <step-container
                :current_step="3"
                :step_list="stepList"
            ></step-container>
        </div>

        <b-container fluid class="mt-0 pb-5">
        
            <b-row>
                <b-col cols="12" md="8" class="mx-auto">
                    <div id="body-container" v-if="add_beneficiary">
                        <div class="p-0 pb-5 text-center">
                            <img :src="`${publicPath}/img/gep/withdrawal-icon.svg`" style="background-color: #EDF8F1;border-radius: 20px;">
                            <h5 class="my-3">Beneficiary (Same Name)</h5>
                            <hr/>
                            <div class="d-flex mb-3">
                                <div>Account Type</div>
                                <div class="ml-auto fw-700">{{ add_beneficiary.accType==1?'Business':'Individual' }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Account Currency</div>
                                <div class="ml-auto fw-700">{{ add_beneficiary.accountCcy }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Account Name</div>
                                <div class="ml-auto fw-700">{{ add_beneficiary.accountName }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Card Number</div>
                                <div class="ml-auto fw-700">{{ add_beneficiary.cardNo }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Bank Name</div>
                                <div class="ml-auto fw-700">{{ add_beneficiary.bankName }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Bank Branch Name</div>
                                <div class="ml-auto fw-700">{{ add_beneficiary.bankBranchName }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Country</div>
                                <div class="ml-auto fw-700">{{ add_beneficiary.currentCountry }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Swift Code</div>
                                <div class="ml-auto fw-700">{{ add_beneficiary.swiftCode }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Bank code</div>
                                <div class="ml-auto fw-700">{{ add_beneficiary.clearingCode }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Beneficiary Address</div>
                                <div class="ml-auto fw-700">{{ add_beneficiary.payeeAddress }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Bank Address</div>
                                <div class="ml-auto fw-700">{{ add_beneficiary.bankAddress }}</div>
                            </div>
                            <hr/>
                            <div class="d-flex mb-0">
                                <button @click="$router.go(-1);" class="btn btn-previous d-block mr-auto">{{ $t('Previous') }}</button>
                                <button @click="doSubmit" class="btn btn-primary d-block">{{ $t('Submit') }}</button>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        
      </b-container>
      <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
  </template>
  <script>
  
    import LoaderComponent from "@/components/LoaderComponent";
    import stepContainer from "@/components/CardManagement/stepContainer";
    import Global from '@/services/Global';
    import Withdrawal from "@/services/Withdrawal";
  
    export default {
        name: 'beneficiary-summary',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                isLoading : false,
                add_beneficiary: null,
                stepList:["Select Withdrawal","Fill Information", "Beneficiary Summary"]
            }
        },
        components: {
            LoaderComponent,
            stepContainer
        },
        methods:{
            getCostBorne(type){
                return this.costBorne[type];
            },
            getPurpose(type){
                return this.paymentPurposeOpt[parseInt(type)+1].text;
            },
            getAmount(amount){
                return Global.addCommas(amount);
            },
            getMessage: function (key) {
                return this.$t(key)
            },
            doSubmit(){
                let self = this;
                this.isLoading = true;
                Withdrawal.addBenificiary({
                    accType:parseInt(this.add_beneficiary.accType),
                    accountCcy:this.add_beneficiary.accountCcy,
                    accountName:this.add_beneficiary.accountName,
                    userNo:this.add_beneficiary.userNo,
                    cardNo:this.add_beneficiary.cardNo,
                    bankName:this.add_beneficiary.bankName,
                    bankBranchName:this.add_beneficiary.bankBranchName,
                    countryCode:this.add_beneficiary.countryCode,
                    swiftCode:this.add_beneficiary.swiftCode,
                    clearingCode:this.add_beneficiary.clearingCode,
                    payeeAddress:this.add_beneficiary.payeeAddress,
                    bankAddress:this.add_beneficiary.bankAddress
                }).then((response)=>{
                    if (response.status == 200) {
                        self.isLoading = false;
                        let data = response.data.data;
                        localStorage.removeItem('add_beneficiary');
                        
                        self.$swal({
                            icon: 'success',
                            title: self.getMessage('Success'),
                            showConfirmButton: true,
                        }).then((result) => {
                            localStorage.removeItem('add_beneficiary');
                            self.$router.push({ 
                                path: '/beneficiaries', 
                            });
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    self.checkError(err);
                });
            },
            checkError(err){
                this.isLoading = false;
                const response = err.response;  
                console.log("===================");
                let self = this;
                if(response.status == 400){
                    console.log(response.data);
                    if(typeof response.data.message === 'string'){
                        this.$swal({
                            icon: 'info',
                            html:response.data.message,
                            showConfirmButton: true,
                            confirmButtonText: self.getMessage('OK')
                        });
                    }
                    else{
                        if(response.data.message['errorMsg']){
                            this.$swal({
                                icon: 'info',
                                html:response.data.message['errorMsg'],
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                        else{
                            let ret = [];
                            Object.keys(response.data.message).forEach((key) => {
                                ret.push(response.data.message[key][0]);
                            });

                            this.$swal({
                                icon: 'info',
                                html:ret.join("<br>"),
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                    }
                }      
                else if(response.status == 401 && response.data.name == "Unauthorized"){
                        localStorage.removeItem("token");
                        localStorage.removeItem("member");
                        localStorage.removeItem("isFirstTime");
                        this.$router.push({ 
                            path: '/login', 
                        });
                }
                else{
                    if(localStorage.getItem("token")){
                        var msg = (response.data)?response.data.message:err.message;
                        this.$swal({
                            icon: 'info',
                            html:msg,
                            showConfirmButton: true,
                            confirmButtonText: self.getMessage('OK')
                        });
                    }
                }
            }
        },
        mounted(){
            const add_beneficiary = JSON.parse(localStorage.getItem('add_beneficiary'));
            this.add_beneficiary = add_beneficiary;
            console.log(this.add_beneficiary);
        }
    };
  </script>

<style scoped>
ul li{
    list-style: disc;
}
.point .number{
    background-color: rgba(103, 163, 83, 1);
    border-radius: 50%;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    padding: 3px;
    font-weight: 500;
    color: #fff;
}
.account-type:hover{
    background: linear-gradient(90deg, #00AEEF 0%, #0972D3 100%) !important;
}
.block-item{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}
hr{
    border-style: dashed;
}
</style>